import React, { useContext } from "react";
import { UI } from "@wwimmo/ui";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { ColorStyle } from "src/utils/Colors";
import { RootStoreContext } from "src/stores/RootStore";
import { TakeOverTicketButton } from "src/screens/tickets/ticket/details/actions/takeOverTicket/TakeOverTicketButton";
import { AssignTicketButtonAndModal } from "src/screens/tickets/ticket/details/actions/assignTicket/AssignTicketButtonAndModal";
import { TICKET_ORIGIN, TICKET_STATE } from "src/stores/TicketStore";

const TicketWorkflowCardBase = () => {
    const { t } = useTranslation();
    const { ticketStore } = useContext(RootStoreContext);

    const assignedUser = ticketStore.currentTicket?.assignedUser ?? undefined;
    const assignedUserName = assignedUser
        ? `${assignedUser.name1 ?? ""} ${
              assignedUser.name2 && assignedUser.name2.trim() !== assignedUser.name1.trim() ? assignedUser.name2 : ""
          }`.trim()
        : "-";

    return (
        <UI.Card title={t("screens.tickets.workflow.title").toString()} flex>
            {ticketStore.currentTicket?.origin === TICKET_ORIGIN.MANUAL &&
            ticketStore.currentTicket?.state === TICKET_STATE.NEW ? (
                <UI.RotatingSpinner noLogo={true} size={25} />
            ) : (
                <>
                    {(ticketStore.currentTicket?.realestate?.id === undefined || ticketStore.isEditing) &&
                    ticketStore.currentTicket?.state === TICKET_STATE.NEW &&
                    ticketStore.currentTicket?.origin === TICKET_ORIGIN.EASY_CONTACT ? (
                        <span className="error-text">{t("screens.tickets.workflow.assign_realestate").toString()}</span>
                    ) : (
                        <>
                            <div className="d-flex align-items-center">
                                <UI.Icon icon={UI.SVGIcon.Profile} color={ColorStyle("primary")} className="mr-1" />
                                <div>{assignedUserName}</div>
                            </div>
                            <TakeOverTicketButton />
                            <AssignTicketButtonAndModal />
                        </>
                    )}
                </>
            )}
        </UI.Card>
    );
};

export const TicketWorkflowCard = Sentry.withProfiler(observer(TicketWorkflowCardBase));
